import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as n, renderSlot as H, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, M = { key: 1 }, Z = { key: 2 }, f = { key: 3 }, h = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconMapPinSimpleLine"
}, _ = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: l } = m(s);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      H(i.$slots, "default"),
      n(l) === "bold" ? (o(), e("g", V, t[0] || (t[0] = [
        a("path", { d: "M216,204H140V138.79a60,60,0,1,0-24,0V204H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM92,80a36,36,0,1,1,36,36A36,36,0,0,1,92,80Z" }, null, -1)
      ]))) : n(l) === "duotone" ? (o(), e("g", M, t[1] || (t[1] = [
        a("path", {
          d: "M176,80a48,48,0,1,1-48-48A48,48,0,0,1,176,80Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M216,208H136V135.42a56,56,0,1,0-16,0V208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM88,80a40,40,0,1,1,40,40A40,40,0,0,1,88,80Z" }, null, -1)
      ]))) : n(l) === "fill" ? (o(), e("g", Z, t[2] || (t[2] = [
        a("path", { d: "M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16h80V135.42a56,56,0,1,1,16,0V208h80A8,8,0,0,1,224,216Z" }, null, -1)
      ]))) : n(l) === "light" ? (o(), e("g", f, t[3] || (t[3] = [
        a("path", { d: "M216,210H134V133.66a54,54,0,1,0-12,0V210H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM86,80a42,42,0,1,1,42,42A42,42,0,0,1,86,80Z" }, null, -1)
      ]))) : n(l) === "regular" ? (o(), e("g", h, t[4] || (t[4] = [
        a("path", { d: "M216,208H136V135.42a56,56,0,1,0-16,0V208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM88,80a40,40,0,1,1,40,40A40,40,0,0,1,88,80Z" }, null, -1)
      ]))) : n(l) === "thin" ? (o(), e("g", k, t[5] || (t[5] = [
        a("path", { d: "M216,212H132V131.83a52,52,0,1,0-8,0V212H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM84,80a44,44,0,1,1,44,44A44.05,44.05,0,0,1,84,80Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  _ as default
};
